import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 500.000000 500.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)">

<path d="M2255 4474 c-233 -34 -438 -99 -645 -202 -187 -94 -325 -191 -476
-335 -306 -293 -498 -638 -586 -1053 -21 -98 -23 -136 -23 -379 0 -244 2 -280
23 -377 75 -350 206 -626 423 -893 68 -84 231 -243 315 -307 235 -180 533
-316 824 -375 106 -22 159 -27 351 -30 212 -5 236 -3 370 21 425 78 771 257
1065 551 282 282 467 623 549 1015 36 167 45 464 21 645 -101 759 -621 1388
-1348 1630 -228 76 -307 88 -588 91 -135 1 -258 0 -275 -2z m510 -34 c309 -46
609 -164 859 -338 197 -137 424 -381 550 -591 278 -459 354 -1027 208 -1546
-51 -181 -151 -397 -255 -549 -34 -50 -64 -93 -67 -96 -3 -3 -18 -23 -35 -45
-38 -52 -248 -262 -300 -300 -22 -17 -42 -32 -45 -36 -9 -10 -94 -66 -185
-120 -97 -59 -171 -96 -255 -129 -91 -36 -63 -16 41 29 83 36 300 157 343 192
6 5 45 35 86 67 113 88 189 161 276 267 212 257 344 528 420 860 24 105 28
147 32 333 3 168 1 240 -13 335 -42 293 -155 581 -328 837 -97 144 -308 360
-441 454 -274 193 -461 274 -811 353 -66 15 -126 18 -345 18 -289 0 -339 -7
-565 -74 -140 -42 -171 -54 -298 -117 -611 -307 -1023 -907 -1077 -1573 -25
-304 30 -653 145 -926 118 -281 325 -558 554 -742 268 -217 550 -351 871 -415
102 -20 144 -23 375 -23 301 0 353 8 653 101 14 5 14 4 2 -4 -59 -39 -328 -97
-521 -113 -350 -30 -762 57 -1064 225 -196 109 -325 207 -481 367 -153 158
-254 301 -349 493 -232 472 -266 1001 -98 1506 56 170 195 422 312 570 94 118
234 256 346 341 290 222 645 361 1010 399 104 10 348 5 450 -10z m87 -54 c533
-101 1025 -441 1292 -896 452 -767 334 -1724 -289 -2345 -741 -738 -1920 -753
-2679 -34 -155 146 -294 335 -390 525 -134 270 -193 508 -203 824 -4 135 -2
202 11 290 61 418 234 778 516 1074 308 324 721 528 1180 585 135 17 408 6
562 -23z"/>
<path d="M3055 3281 c-149 -25 -277 -117 -333 -240 -21 -47 -25 -71 -26 -156
0 -55 5 -119 12 -142 l13 -43 146 0 145 0 -37 41 c-54 60 -75 112 -75 189 0
166 112 250 315 237 49 -3 110 -12 135 -19 l45 -14 45 -157 c44 -153 46 -157
72 -157 23 0 29 6 37 38 13 48 39 232 43 302 l3 55 -50 17 c-130 43 -376 67
-490 49z"/>
<path d="M1545 3269 c-49 -4 -165 -7 -257 -8 l-168 -1 0 -33 c0 -32 3 -34 63
-55 34 -11 77 -24 95 -27 l32 -7 0 -219 0 -219 110 0 110 0 0 224 c0 260 -13
236 130 236 145 0 267 -39 333 -106 70 -70 98 -148 99 -275 l0 -80 122 3 121
3 3 54 c7 118 -31 247 -98 331 -38 48 -148 121 -215 144 -119 40 -279 52 -480
35z"/>
<path d="M1655 2505 c0 -59 2 -65 21 -65 17 0 20 5 17 23 -3 17 2 25 26 34 23
8 31 18 31 36 0 28 -16 37 -63 37 l-32 0 0 -65z m71 16 c-11 -18 -36 -13 -36
7 0 10 3 22 7 26 10 10 37 -20 29 -33z"/>
<path d="M1852 2554 c-50 -35 -10 -122 50 -110 56 11 72 55 37 100 -23 29 -54
33 -87 10z m67 -30 c21 -48 -13 -86 -47 -52 -13 13 -16 60 -5 71 15 15 40 5
52 -19z"/>
<path d="M2056 2547 c-46 -46 -7 -115 59 -103 19 4 35 11 35 16 0 5 -13 7 -28
4 -35 -7 -55 14 -50 53 3 25 6 28 41 27 46 -2 45 20 -1 24 -23 2 -38 -3 -56
-21z"/>
<path d="M2235 2505 c0 -56 2 -65 18 -65 14 0 17 5 12 19 -9 30 11 34 29 6 9
-14 26 -25 37 -25 19 0 18 3 -11 36 l-31 36 20 22 c24 26 26 36 8 36 -7 0 -17
-10 -22 -22 -15 -33 -37 -36 -29 -4 5 21 3 26 -12 26 -17 0 -19 -8 -19 -65z"/>
<path d="M2428 2505 l-3 -65 53 0 c48 0 52 2 51 23 0 12 -3 16 -6 10 -2 -7
-18 -13 -35 -13 -23 0 -29 4 -26 18 3 11 12 16 26 15 14 -2 22 3 22 12 0 11
-7 14 -25 9 -21 -5 -25 -3 -25 15 0 21 7 25 49 21 14 -1 21 2 17 9 -4 6 -27
11 -51 11 l-43 0 -4 -65z"/>
<path d="M2607 2563 c-4 -3 -7 -13 -7 -22 0 -12 3 -12 12 -3 7 7 18 12 26 12
12 0 14 -11 9 -55 -5 -49 -4 -55 13 -55 17 0 18 6 13 55 -5 44 -3 55 9 55 8 0
19 -5 26 -12 9 -9 12 -7 12 10 0 20 -5 22 -53 22 -30 0 -57 -3 -60 -7z"/>
<path d="M2812 2558 c-21 -21 -13 -45 18 -58 17 -7 30 -19 30 -26 0 -17 -32
-18 -49 -1 -10 10 -12 8 -9 -8 2 -13 12 -21 31 -23 58 -7 78 47 27 73 -16 9
-30 20 -30 25 0 14 34 12 49 -2 10 -11 12 -9 9 7 -4 24 -56 33 -76 13z"/>
<path d="M2978 2565 c-10 -10 9 -107 23 -116 12 -9 66 -5 76 5 2 2 7 30 10 61
5 45 3 57 -7 53 -8 -2 -14 -22 -14 -54 -1 -45 -3 -49 -26 -49 -23 0 -25 4 -28
53 -3 47 -16 65 -34 47z"/>
<path d="M3175 2505 l0 -65 42 0 c59 0 94 37 56 59 -14 8 -15 12 -4 25 21 25
-3 46 -53 46 l-41 0 0 -65z m75 30 c0 -8 -9 -15 -20 -15 -11 0 -20 7 -20 15 0
8 9 15 20 15 11 0 20 -7 20 -15z m8 -56 c3 -17 -23 -33 -39 -23 -5 3 -9 14 -9
25 0 15 6 20 22 17 13 -2 24 -10 26 -19z"/>
<path d="M1310 2026 l0 -273 -42 -7 c-24 -4 -67 -14 -95 -23 -50 -16 -53 -19
-53 -50 l0 -33 316 0 315 0 -3 32 c-3 35 -28 47 -147 71 l-66 14 -3 254 -2
254 152 1 c96 1 177 7 218 17 63 14 53 15 -262 16 l-328 1 0 -274z"/>
<path d="M3275 2285 c81 -59 117 -96 141 -143 23 -46 26 -61 22 -120 -6 -83
-32 -136 -94 -191 -60 -53 -148 -81 -253 -81 -89 0 -136 11 -174 42 -23 19
-35 50 -74 191 -46 164 -47 167 -74 167 -25 0 -28 -4 -38 -52 -15 -71 -39
-251 -42 -312 -3 -46 -1 -51 26 -68 94 -57 293 -94 445 -83 256 18 426 137
476 335 22 86 15 206 -16 278 l-22 52 -172 0 c-152 -1 -169 -2 -151 -15z"/>
<path d="M1368 1523 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2143 1490 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M2563 1490 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M2580 1526 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M3148 1495 c9 -19 17 -33 19 -31 6 5 -19 66 -27 66 -4 0 0 -16 8 -35z"/>
<path d="M3203 1490 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M3420 1521 c0 -5 7 -11 14 -14 10 -4 13 -1 9 9 -6 15 -23 19 -23 5z"/>
<path d="M3020 1511 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M1562 1490 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M1672 1490 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M2270 1505 c0 -3 9 -14 20 -25 12 -12 20 -15 20 -7 0 7 -9 18 -20 25
-11 7 -20 10 -20 7z"/>
<path d="M2972 1485 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M3582 1485 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M2586 1493 c6 -4 14 -15 17 -23 5 -11 6 -9 4 4 -1 11 -9 21 -17 23
-10 3 -11 2 -4 -4z"/>
<path d="M1855 1470 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M3461 1473 c7 -10 15 -20 16 -22 2 -2 3 3 3 11 0 9 -7 19 -16 22 -15
6 -15 4 -3 -11z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
